var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1149_26110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 65
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1149_26110)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56093 39.6811C5.98454 39.0367 5.66406 38.202 5.66406 37.3333C5.66406 32.0272 5.66406 19.1611 5.66406 13.8551C5.66406 12.9206 6.03502 12.0249 6.69593 11.3652C7.35567 10.7043 8.25137 10.3333 9.1858 10.3333H56.1423C57.0768 10.3333 57.9725 10.7043 58.6322 11.3652C59.2931 12.0249 59.6641 12.9206 59.6641 13.8551V37.3333C59.6641 38.202 59.3436 39.0367 58.7672 39.6811C59.3436 40.3256 59.6641 41.1603 59.6641 42.029C59.6641 42.8977 59.3436 43.7323 58.7672 44.3768C59.3436 45.0213 59.6641 45.8559 59.6641 46.7246C59.6641 47.5933 59.3436 48.428 58.7672 49.0724C59.3436 49.7169 59.6641 50.5516 59.6641 51.4203C59.6641 52.3547 59.2931 53.2504 58.6322 53.9101C57.9725 54.5711 57.0768 54.942 56.1423 54.942H9.1858C8.25137 54.942 7.35567 54.5711 6.69593 53.9101C6.03502 53.2504 5.66406 52.3547 5.66406 51.4203C5.66406 50.5516 5.98454 49.7169 6.56093 49.0724C5.98454 48.428 5.66406 47.5933 5.66406 46.7246C5.66406 45.8559 5.98454 45.0213 6.56093 44.3768C5.98454 43.7323 5.66406 42.8977 5.66406 42.029C5.66406 41.1603 5.98454 40.3256 6.56093 39.6811ZM29.1423 52.5942V40.8551H36.1858V52.5942H29.1423ZM26.7945 50.2464H9.1858C8.87941 50.2464 8.58476 50.3661 8.36641 50.5797L8.35584 50.5903C8.13515 50.8098 8.01189 51.1092 8.01189 51.4203C8.01189 51.7314 8.13515 52.0307 8.35584 52.2502C8.57537 52.4709 8.87471 52.5942 9.1858 52.5942H26.7945V50.2464ZM38.5336 52.5942V50.2464H56.1423C56.4487 50.2464 56.7434 50.3661 56.9617 50.5797L56.9723 50.5903C57.193 50.8098 57.3162 51.1092 57.3162 51.4203C57.3162 51.7314 57.193 52.0307 56.9723 52.2502C56.7528 52.4709 56.4534 52.5942 56.1423 52.5942H38.5336ZM26.7945 47.8985V45.5507H9.1858C8.87941 45.5507 8.58476 45.6704 8.36641 45.8841L8.35584 45.8947C8.13515 46.1142 8.01189 46.4135 8.01189 46.7246C8.01189 47.0357 8.13515 47.3351 8.35584 47.5546C8.57537 47.7753 8.87471 47.8985 9.1858 47.8985H26.7945ZM56.1423 47.8985H38.5336V45.5507H56.1423C56.4487 45.5507 56.7434 45.6704 56.9617 45.8841L56.9723 45.8947C57.193 46.1142 57.3162 46.4135 57.3162 46.7246C57.3162 47.0357 57.193 47.3351 56.9723 47.5546C56.7528 47.7753 56.4534 47.8985 56.1423 47.8985ZM9.1858 40.8551C8.87941 40.8551 8.58476 40.9748 8.36641 41.1884L8.35584 41.199C8.13515 41.4185 8.01189 41.7179 8.01189 42.029C8.01189 42.34 8.13515 42.6394 8.35584 42.8589C8.57537 43.0796 8.87471 43.2029 9.1858 43.2029H26.7945V40.8551H9.1858ZM38.5336 40.8551H56.1423C56.4487 40.8551 56.7434 40.9748 56.9617 41.1884L56.9723 41.199C57.193 41.4185 57.3162 41.7179 57.3162 42.029C57.3162 42.34 57.193 42.6394 56.9723 42.8589C56.7528 43.0796 56.4534 43.2029 56.1423 43.2029H38.5336V40.8551ZM57.3162 13.8551V37.3333C57.3162 37.6444 57.193 37.9437 56.9723 38.1633C56.7528 38.384 56.4534 38.5072 56.1423 38.5072H9.1858C8.87471 38.5072 8.57537 38.384 8.35584 38.1633C8.13515 37.9437 8.01189 37.6444 8.01189 37.3333V13.8551C8.01189 13.544 8.13515 13.2446 8.35584 13.0251C8.57537 12.8044 8.87471 12.6811 9.1858 12.6811H56.1423C56.4534 12.6811 56.7528 12.8044 56.9723 13.0251C57.193 13.2446 57.3162 13.544 57.3162 13.8551Z",
    fill: "url(#paint0_linear_1149_26110)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2286 26.7681H18.5764C19.2244 26.7681 19.7503 26.2421 19.7503 25.5941C19.7503 24.9461 19.2244 24.4202 18.5764 24.4202H16.2286C15.5806 24.4202 15.0547 24.9461 15.0547 25.5941C15.0547 26.2421 15.5806 26.7681 16.2286 26.7681Z",
    fill: "url(#paint1_linear_1149_26110)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.752 26.7681H49.0999C49.7479 26.7681 50.2738 26.2421 50.2738 25.5941C50.2738 24.9461 49.7479 24.4202 49.0999 24.4202H46.752C46.104 24.4202 45.5781 24.9461 45.5781 25.5941C45.5781 26.2421 46.104 26.7681 46.752 26.7681Z",
    fill: "url(#paint2_linear_1149_26110)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.055 34.9855C15.055 35.6335 15.5809 36.1594 16.2289 36.1594H49.0985C49.7465 36.1594 50.2724 35.6335 50.2724 34.9855C50.2724 33.0415 51.8502 31.4638 53.7942 31.4638C54.4422 31.4638 54.9681 30.9379 54.9681 30.2899V20.8986C54.9681 20.2506 54.4422 19.7246 53.7942 19.7246C51.8502 19.7246 50.2724 18.1469 50.2724 16.2029C50.2724 15.5549 49.7465 15.029 49.0985 15.029H16.2289C15.5809 15.029 15.055 15.5549 15.055 16.2029C15.055 18.1469 13.4773 19.7246 11.5333 19.7246C10.8853 19.7246 10.3594 20.2506 10.3594 20.8986V30.2899C10.3594 30.9379 10.8853 31.4638 11.5333 31.4638C13.4773 31.4638 15.055 33.0415 15.055 34.9855ZM17.2855 33.8116C16.8182 31.5131 15.0057 29.7006 12.7072 29.2333V21.9551C15.0057 21.4879 16.8182 19.6753 17.2855 17.3768H48.042C48.5092 19.6753 50.3217 21.4879 52.6202 21.9551V29.2333C50.3217 29.7006 48.5092 31.5131 48.042 33.8116H17.2855Z",
    fill: "url(#paint3_linear_1149_26110)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6625 19.7246C29.4225 19.7246 26.793 22.3542 26.793 25.5942C26.793 28.8342 29.4225 31.4637 32.6625 31.4637C35.9025 31.4637 38.5321 28.8342 38.5321 25.5942C38.5321 22.3542 35.9025 19.7246 32.6625 19.7246ZM32.6625 22.0724C34.6065 22.0724 36.1843 23.6502 36.1843 25.5942C36.1843 27.5382 34.6065 29.1159 32.6625 29.1159C30.7185 29.1159 29.1408 27.5382 29.1408 25.5942C29.1408 23.6502 30.7185 22.0724 32.6625 22.0724Z",
    fill: "url(#paint4_linear_1149_26110)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1149_26110",
    x1: 5.66406,
    y1: 32.6377,
    x2: 59.6641,
    y2: 32.6377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1149_26110",
    x1: 15.0547,
    y1: 25.5941,
    x2: 19.7503,
    y2: 25.5941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1149_26110",
    x1: 45.5781,
    y1: 25.5941,
    x2: 50.2738,
    y2: 25.5941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1149_26110",
    x1: 10.3594,
    y1: 25.5942,
    x2: 54.9681,
    y2: 25.5942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1149_26110",
    x1: 26.793,
    y1: 25.5942,
    x2: 38.5321,
    y2: 25.5942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.ef68213a92923228ac4635fd366c214f.svg";
export { ForwardRef as ReactComponent };